const flattenValue = (value) => {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    return value
      .map((entry) => flattenValue(entry))
      .filter(Boolean)
      .join(', ');
  }

  if (typeof value === 'object') {
    const parts = Object.entries(value)
      .map(([key, entry]) => {
        const flattened = flattenValue(entry);
        if (!flattened) {
          return '';
        }
        const normalizedKey = key.replace(/_/g, ' ');
        return `${normalizedKey}: ${flattened}`;
      })
      .filter(Boolean);

    return parts.join(' | ');
  }

  return String(value);
};

export const formatApiError = (error, fallback = 'Something went wrong') => {
  if (!error) {
    return fallback;
  }

  if (error.response?.data) {
    return formatApiError(error.response.data, fallback);
  }

  if (error.error) {
    return formatApiError(error.error, fallback);
  }

  const result = flattenValue(error);
  return result || fallback;
};
